import { render, staticRenderFns } from "./addPageTransfer.vue?vue&type=template&id=24370c4d&scoped=true&"
import script from "./addPageTransfer.vue?vue&type=script&lang=js&"
export * from "./addPageTransfer.vue?vue&type=script&lang=js&"
import style0 from "./addPageTransfer.vue?vue&type=style&index=0&id=24370c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24370c4d",
  null
  
)

export default component.exports